var dcPoint = {
  "type": "geojson",
  "data": {
    "type": "Feature",
    "properties": {
        "id": "dcPoint",
        "name": "dc",
        "circleRadius": 8,
        "circleColor": "blue",
        "minzoom": null,
        "question": "Why is DC shaped like half a diamond?"
      },
    "geometry": {
        "type": "Point",
        "coordinates": [-77.02980122218949, 38.916042800603975]
    }
  }
}



var dcPossible = {

"type": "geojson",
  "data": {
    "type": "Feature",
    "properties": {
        "id": "dcPossible",
        "name": "dcPossible",
        "fillOpacity": .5,
        "fillColor": "grey",
      },
    "geometry": {
        "type": "Polygon",
        "coordinates": [[

            [
              -76.90940380096436,
              38.89286995617712
            ],
            [
              -77.04102516174316,
              38.995840128965035
            ],
            [
              -77.0855712890625,
              39.055450960258554
            ],
            [
              -77.1514892578125,
              39.095962936305476
            ],
            [
              -77.2064208984375,
              39.11301365149975
            ],
            [
              -77.29705810546874,
              39.13006024213511
            ],
            [
              -77.35748291015625,
              39.14710270770074
            ],
            [
              -77.3492431640625,
              39.198205348894795
            ],
            [
              -77.34100341796875,
              39.2407625100131
            ],
            [
              -77.37396240234375,
              39.28541975943743
            ],
            [
              -77.431640625,
              39.31517545076218
            ],
            [
              -77.45361328125,
              39.35341418045878
            ],
            [
              -77.50579833984375,
              39.35978526869001
            ],
            [
              -77.5579833984375,
              39.39163199379185
            ],
            [
              -77.58270263671875,
              39.41922073655956
            ],
            [
              -77.62664794921875,
              39.459523110465156
            ],
            [
              -77.63763427734375,
              39.49132430037711
            ],
            [
              -77.67333984375,
              39.52522954427751
            ],
            [
              -77.70904541015625,
              39.552765371831015
            ],
            [
              -77.7447509765625,
              39.56547053068434
            ],
            [
              -77.750244140625,
              39.60145584096999
            ],
            [
              -77.75848388671875,
              39.64799732373418
            ],
            [
              -77.76947021484375,
              39.688167045890395
            ],
            [
              -77.82989501953125,
              39.69450749856091
            ],
            [
              -77.86285400390625,
              39.68182601089365
            ],
            [
              -77.86560058593749,
              39.64165260123416
            ],
            [
              -77.82714843749999,
              39.58240712203527
            ],
            [
              -77.88482666015625,
              39.56547053068434
            ],
            [
              -77.95074462890625,
              39.54852980171147
            ],
            [
              -78.00018310546875,
              39.51039803578193
            ],
            [
              -77.93701171875,
              39.45316112807394
            ],
            [
              -77.91778564453125,
              39.40648882684979
            ],
            [
              -77.9150390625,
              39.34067026099156
            ],
            [
              -77.882080078125,
              39.29179704377487
            ],
            [
              -77.81890869140624,
              39.2492708462234
            ],
            [
              -77.75299072265625,
              39.23650795487107
            ],
            [
              -77.67333984375,
              39.21948715423953
            ],
            [
              -77.61566162109375,
              39.20246222588238
            ],
            [
              -77.6348876953125,
              39.16414104768742
            ],
            [
              -77.65960693359375,
              39.12153746241925
            ],
            [
              -77.69805908203125,
              39.07464374293251
            ],
            [
              -77.6568603515625,
              39.049052206453524
            ],
            [
              -77.64862060546875,
              39.01918369029134
            ],
            [
              -77.60467529296875,
              39.00851330385611
            ],
            [
              -77.55523681640625,
              38.98503278695909
            ],
            [
              -77.4700927734375,
              38.97222194853654
            ],
            [
              -77.45361328125,
              38.94872939211095
            ],
            [
              -77.4151611328125,
              38.929502416386605
            ],
            [
              -77.332763671875,
              38.91881851059804
            ],
            [
              -77.266845703125,
              38.90172091499795
            ],
            [
              -77.23114013671875,
              38.8782049970615
            ],
            [
              -77.2119140625,
              38.846125291387025
            ],
            [
              -77.17071533203125,
              38.81403111409755
            ],
            [
              -77.0914077758789,
              38.786472073002834
            ],
            [
              -77.04076766967773,
              38.79031057579223
            ],
            [
              -77.03893303871155,
              38.79163602384671
            ],
            [
              -76.90940380096436,
              38.89286995617712
            ]
          ]
        ]
    }
  }
}

var mountVernonPoint = {

  "type": "geojson",
  "data": {

    "geometry": {
      "coordinates":[-77.086358, 38.707856],
      "type": "Point"
    },
    "type": "Feature",
    "properties": {
      "id": "mountVernonPoint",
      "name": "mountVernonPoint",
      "circleRadius": 8,
      "circleColor": "blue",
    }
  }

}

var alexandriaPoint = {

  "type": "geojson",
  "data": {

    "geometry": {
      "coordinates":[-77.04298715571986, 38.80497399019529],
      "type": "Point"
    },
    "type": "Feature",
    "properties": {
      "id": "alexandriaPoint",
      "name": "alexandriaPoint",
      "circleRadius": 8,
      "circleColor": "blue",
    }
  }

}



var dcSquare = {

"type": "geojson",
  "data": {
    "type": "Feature",
    "properties": {
        "id": "dcSquare",
        "name": "dcSquare",
        "fillOpacity": .5,
        "fillColor": "grey",
      },
    "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.04076766967773,
              38.79034402588856
            ],
            [
              -77.03928709030151,
              38.791406058285716
            ],
            [
              -77.0380425453186,
              38.792317553788365
            ],
            [
              -77.03643321990967,
              38.79354679990656
            ],
            [
              -77.03016757965088,
              38.79858063426498
            ],
            [
              -76.96386337280273,
              38.850804483217395
            ],
            [
              -76.91322326660156,
              38.88996392916758
            ],
            [
              -76.90937161445618,
              38.892863693315725
            ],
            [
              -76.93425178527832,
              38.91234060936887
            ],
            [
              -76.95322036743164,
              38.92726560678006
            ],
            [
              -76.97201728820801,
              38.94192043445515
            ],
            [
              -76.98716640472412,
              38.95376893466979
            ],
            [
              -77.00210094451904,
              38.965415247929535
            ],
            [
              -77.02789306640625,
              38.985566521593654
            ],
            [
              -77.04101979732513,
              38.99585055191651
            ],
            [
              -77.04187005758286,
              38.99518973375562
            ],
            [
              -77.05887794494629,
              38.981796934588864
            ],
            [
              -77.07415580749512,
              38.969919755358
            ],
            [
              -77.08673000335693,
              38.95997609057973
            ],
            [
              -77.11355209350585,
              38.93938359675638
            ],
            [
              -77.11973190307617,
              38.93430964907219
            ],
            [
              -77.17211812734604,
              38.89321441270375
            ],
            [
              -77.04076766967773,
              38.79034402588856
            ]
          ]
        ]
    }
  }
}

var dcBadSquare = {

"type": "geojson",
  "data": {
    "type": "Feature",
    "properties": {
        "id": "dcBadSquare",
        "name": "dcBadSquare",
        "fillOpacity": .3,
        "fillColor": "red",
      },
    "geometry": {
        "type": "Polygon",
        "coordinates": [
          [

            [-76.87268062, 38.8641433],
            [-77.00227906, 38.96646934],
            [-77.13542713, 38.86449402],
            [-77.00407667, 38.76162364

            ]

        ]
      ]
    }
  }
}

var fullDC = {

"type": "geojson",
  "data": {
    "type": "Feature",
    "properties": {
        "id": "fullDC",
        "name": "fullDC",
        "fillOpacity": .3,
        "fillColor": "red",
      },
    "geometry": {
        "type": "Polygon",
        "coordinates":
[
[
[
-77.119751,
38.934349999999995
],
[
-77.041018,
38.995548
],
[
-77.013763,
38.974781
],
[
-76.909393,
38.892852
],
[
-77.039006,
38.791644999999995
],
[
-77.039191,
38.800495999999995
],
[
-77.03728799999999,
38.810527
],
[
-77.03734299999999,
38.814634999999996
],
[
-77.038412,
38.816089999999996
],
[
-77.03912,
38.818885
],
[
-77.038923,
38.819503999999995
],
[
-77.03997199999999,
38.820254
],
[
-77.039496,
38.821656
],
[
-77.040758,
38.822089999999996
],
[
-77.041107,
38.822939999999996
],
[
-77.040618,
38.823603999999996
],
[
-77.03878399999999,
38.824473
],
[
-77.03775499999999,
38.830138
],
[
-77.03911599999999,
38.832100000000004
],
[
-77.041889,
38.833709999999996
],
[
-77.042579,
38.833332
],
[
-77.041984,
38.831483999999996
],
[
-77.043207,
38.83143
],
[
-77.04521799999999,
38.835927999999996
],
[
-77.045273,
38.838476
],
[
-77.04651299999999,
38.839894
],
[
-77.04587,
38.840148
],
[
-77.047489,
38.840655
],
[
-77.048025,
38.841259
],
[
-77.046146,
38.841183
],
[
-77.04473899999999,
38.840213999999996
],
[
-77.04340599999999,
38.840558
],
[
-77.043065,
38.839794999999995
],
[
-77.04178399999999,
38.839515999999996
],
[
-77.036804,
38.839405
],
[
-77.034593,
38.840101
],
[
-77.03306599999999,
38.844549
],
[
-77.03226699999999,
38.848016
],
[
-77.03221099999999,
38.851672
],
[
-77.032843,
38.855027
],
[
-77.03417,
38.857679999999995
],
[
-77.035387,
38.859749
],
[
-77.036805,
38.861111
],
[
-77.03758499999999,
38.861264999999996
],
[
-77.038082,
38.863293
],
[
-77.039738,
38.863240999999995
],
[
-77.04037,
38.862375
],
[
-77.042763,
38.863372
],
[
-77.042452,
38.863945
],
[
-77.040787,
38.863659999999996
],
[
-77.03792399999999,
38.864284
],
[
-77.037998,
38.866664
],
[
-77.039464,
38.869732
],
[
-77.043334,
38.87411
],
[
-77.045869,
38.875613
],
[
-77.047219,
38.874958
],
[
-77.04639399999999,
38.873965999999996
],
[
-77.046517,
38.872057
],
[
-77.049154,
38.871314
],
[
-77.05015499999999,
38.871646999999996
],
[
-77.051682,
38.873906
],
[
-77.051531,
38.876563999999995
],
[
-77.054141,
38.879712
],
[
-77.05558099999999,
38.880342
],
[
-77.057931,
38.880261999999995
],
[
-77.059141,
38.880914
],
[
-77.064251,
38.888956
],
[
-77.064409,
38.889598
],
[
-77.063773,
38.89019
],
[
-77.06398999999999,
38.890944
],
[
-77.067224,
38.897161
],
[
-77.067572,
38.899229
],
[
-77.068641,
38.900287999999996
],
[
-77.070657,
38.901195
],
[
-77.07337299999999,
38.901123
],
[
-77.078248,
38.902367999999996
],
[
-77.082656,
38.902274
],
[
-77.093216,
38.905767
],
[
-77.102032,
38.911916
],
[
-77.103415,
38.913281
],
[
-77.104134,
38.915923
],
[
-77.105587,
38.917629999999996
],
[
-77.10680099999999,
38.920026
],
[
-77.112659,
38.924656999999996
],
[
-77.115957,
38.928165
],
[
-77.116466,
38.929631
],
[
-77.119751,
38.934349999999995
]
]
]

    }
  }
}



// console.log(data[0].addaLayer.layer)

module.exports = {
  name: "dc",
  data: null,
  layers: [dcPossible, mountVernonPoint, dcSquare, dcBadSquare, alexandriaPoint, fullDC],
  visibleLayers: [dcPoint]
  // visibleLayers: [{"michigan": michPoint}]
}



// WEBPACK FOOTER //
// ./src/initialLayers/dc.js